import IPayload from "../interfaces/IPayload";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";

class Rebalance {
    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.rebalanceUsina}/GetWithFilter/${ToQueryString(filters)}`);
    }

    async getUsinasByConcessionaria(filters: any) {
        return await api.get<any>(`${resources.rebalanceUsina}/GetUsinasByConcessionaria/${ToQueryString(filters)}`);
    }

    async getHistorico(filters: any) {
        return await api.get<IPayload>(`${resources.rebalanceUsina}/GetHistorico/${ToQueryString(filters)}`);
    }

    async setCurrent(data: any) {
        return await api.post<any>(`${resources.rebalanceUsina}/SetCurrent`, data);
    }

    async getStatusRebalance() {
        return await api.get<any>(`${resources.rebalanceUsina}/GetStatusRebalance`);
    }

    async start(data: any) {
        return await api.post<any>(`${resources.rebalanceUsina}/Start`, data);
    }

    async process(data: any) {
        return await api.post<any>(`${resources.rebalanceUsina}/Process`, data);
    }

    async upload(data: any) {
        return await api.post<any>(`${resources.rebalanceUsina}/Upload`, data);
    }

    async sankhya(data: any) {
        return await api.post<any>(`${resources.rebalanceUsina}/Sankhya`, data);
    }

    async download(filters: any) {
        return await api.get<any>(`${resources.rebalanceUsina}/Download/${ToQueryString(filters)}`);
    }

    async approve(data: any) {
        return await api.post<any>(`${resources.rebalanceUsina}/Approve`, data);
    }

    async reopen(data: any) {
        return await api.post<any>(`${resources.rebalanceUsina}/Reopen`, data);
    }

    async approveConcessionaria(data: any) {
        return await api.post<any>(`${resources.rebalanceUsina}/ApproveConcessionaria`, data);
    }

    async sendConcessionaria(data: any) {
        return await api.post<any>(`${resources.rebalanceUsina}/SendConcessionaria`, data);
    }

    async getListaErros(filters: any) {
        return await api.get(`${resources.rebalanceUsina}/GetListaErros/${ToQueryString(filters)}`);
    }

    async restart(data: any) {
        return await api.post<any>(`${resources.rebalanceUsina.toLowerCase()}/restart`, data);
    }

    async getLayoutDownload() {
        return await api.get<any>(`${resources.rebalanceUsina.toLowerCase()}/layoutDownload`);
    }

    async setLayoutDownload(data: any) {
        return await api.post<any>(`${resources.rebalanceUsina.toLowerCase()}/layoutDownload`, data);
    }

    async getGanhoFinanceiro(filters: { usinaID: number | string; mes: number | string; ano: number | string }) {
        const params = {
            UsinaID: filters.usinaID,
            Mes: filters.mes,
            Ano: filters.ano,
        };

        return await api.get<any>(`${resources.rebalanceUsina}/GanhoFinanceiro${ToQueryString(params)}`, {
            validateStatus: (status) => status === 200 || status === 400,
        });
    }
}

export default new Rebalance();
